<template>
    <div>
        <el-row>
            <el-col :span="2"><div class="grid-content"></div></el-col>
            <el-col :span="20">
                <div class="title">
                    <h1>Visualization of knowledge map</h1>
                </div>
                <div class="picture">
                    <img src="../assets/project6_1.png">
                </div>
                <div class="abstract">
                    It's a knowledge map about the field of design study. It will provide a quick inquiry by using Neo4j graph database. This project use d3.js to visualize the map on web page.
                    <br><br>
                    Click
                    <a target="_blank" href="https://odumbledorearmyo.github.io/Design-Study-Knowledge-Map/" style="color:#000; font-weight: bold">
                        HERE
                    </a>
                    to see the web.
                </div>
            </el-col>
            <el-col :span="2"><div class="grid-content"></div></el-col>
        </el-row>
        <el-row :gutter="40" style="margin-top: 50px">
            <el-col :span="2"><div class="grid-content"></div></el-col>
            <el-col :span="20">
                <div class="sub-title">
                    Data source and modification            </div>
                <div class="text">
                    The database is create by myself based on literature review. So basically it's a personal knowledge database. The database is recorded as Cypher in the txt file. If you want to modify the data, copy the code in the txt file to Neo4j and the database will be created locally. Then modify them in Neo4j as you like. But remember to run the Match2D3.java again after modifying the data, so the map will change to show your database. The database will keep updating.
                </div>
            </el-col>
            <el-col :span="2"><div class="grid-content"></div></el-col>
        </el-row>
        <el-row :gutter="40" style="margin-top: 50px">
            <el-col :span="2"><div class="grid-content"></div></el-col>
            <el-col :span="20">
                <div class="sub-title">
                    Tech stack              </div>
                <div class="text">
                    Neo4j(Cypher) + Java API + D3.js + HTML
                    <br><br> Click
                    <a target="_blank" href="https://github.com/oDumbledoreArmyo/Design-Study-Knowledge-Map" style="color:#000; font-weight: bold">
                        HERE
                    </a>
                    to see the project on Github.
               </div>
            </el-col>

            <el-col :span="2"><div class="grid-content"></div></el-col>
        </el-row>

    </div>
</template>

<script>
    export default {
        name: "Project1"
    }
</script>

<style scoped>
    .picture img{
        width: 100%;
    }
    .sub-title{
        margin-bottom: 20px;
        font-size: 15px;
        color: #666;
        font-weight: 400;
        text-align: justify;
    }
    .text{
        font-size: 15px;
        color: #333;
        font-weight: 100;
        text-align: justify;
    }
    .abstract{
        margin-top: 40px;
        font-size: 15px;
        color: #333;
        font-weight: 100;
        text-align: justify;
    }
    video{
        width: 100%;
    }
    .grid-content{
        min-height: 36px;
    }
    .video{
        margin-top: 100px;
    }
    .title{
        margin-top: 100px;
        text-align: center;

    }
    .title a{
        color: #333;
    }
    .title p{
        color: #aaa;
        line-height: 30px;
    }
    .title h1{
        font-size:30px;
        font-weight: 100;
        letter-spacing:6px;
        color: #333333;
    }
</style>